// @flow
export const DISMISS_ALERT = 'hive/alerts/DISMISS_ALERT';
export const REQUEST_ALERT = 'hive/alerts/REQUEST_ALERT';
export const DISMISS_ALL_ALERTS = 'hive/alerts/DISMISS_ALL_ALERTS';



// WEBPACK FOOTER //
// ./src/core/state/alerts/constants.js